module.exports = __webpack_public_path__ + "0a6af8565bcae09066dae25a9c890d84.MP3";